const ADD_DOCUMENTS_ROUTES = {
  PROPOSAL: (id) => `/proposals/view/${id}/general/documents`,
  OPPORTUNITY: (id) => `/capture/tracked-opportunities/${id}/summary/solicitation`,
  CONTRACT: (id) => `/contracts/all/${id}/summary/documents`,
  MISC_ANALYSIS: (id) => `/misc-analysis/view/${id}/general/documents`,
};

export const getAddDocumentsRoute = (entityType, entityId) =>
  entityId != null ? ADD_DOCUMENTS_ROUTES[entityType]?.(entityId) : undefined;
